import { motion, AnimatePresence } from 'framer-motion';
import { useEffect } from 'react';
import clsx from 'clsx';

type ToastType = 'success' | 'error' | 'info';

interface ToastProps {
  message: string;
  type?: ToastType;
  onClose: () => void;
  duration?: number;
  /**
   * Daca true, toast-ul se randeaza inline (fara pozitionare fixa).
   * Folosit in AdminBar pentru a afisa notificarile in bara, nu ca overlay.
   */
  inline?: boolean;
}

export function Toast({ message, type = 'info', onClose, duration = 4000, inline = false }: ToastProps) {
  useEffect(() => {
    const timer = setTimeout(onClose, duration);
    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const icons = {
    success: '✓',
    error: '✕',
    info: 'ⓘ',
  };

  const colors = {
    success: 'bg-success text-bg-alt',
    error: 'bg-error text-bg-alt',
    info: 'bg-bg text-fg',
  };

  const baseClasses = inline
    ? 'flex items-center gap-sm rounded-md px-md py-xs text-sm font-medium border'
    : 'fixed right-md top-md z-toast flex items-center gap-sm rounded-md px-md py-sm shadow-md max-w-sm';

  return (
    <AnimatePresence>
      <motion.div
        initial={inline ? { opacity: 0, y: -8 } : { x: 100, opacity: 0 }}
        animate={inline ? { opacity: 1, y: 0 } : { x: 0, opacity: 1 }}
        exit={inline ? { opacity: 0, y: -8 } : { x: 100, opacity: 0 }}
        transition={{ duration: 0.25, ease: 'easeOut' }}
        className={clsx(baseClasses, colors[type])}
        role="status"
      >
        <span className="text-base font-bold">{icons[type]}</span>
        <span className="text-sm">{message}</span>
      </motion.div>
    </AnimatePresence>
  );
}